import constants from '@/common/constants';
import { checkMenuGuard } from '@/common/utils';

export const routes = [
  {
    path: constants.PATHS.INTERNATIONAL_TRADE,
    component: () => import('@/app/modules/InternationalTrade/views/InternationalTrade.vue'),
    beforeEnter: checkMenuGuard,
  },
  {
    path: constants.PATHS.ANALITCS_SERVICES,
    component: () => import('@/app/modules/InternationalTrade/views/AnalyticsServices.vue'),
    beforeEnter: checkMenuGuard,
  },
  {
    path: constants.PATHS.ANALITCS_PRODUCTS,
    component: () => import('@/app/modules/InternationalTrade/views/AnalyticsProducts.vue'),
    beforeEnter: checkMenuGuard,
  },
  {
    path: constants.PATHS.TRADE_IN_SERVICES,
    component: () => import('@/app/modules/InternationalTrade/views/TradeInServices.vue'),
    beforeEnter: checkMenuGuard,
  },
  {
    path: constants.PATHS.TRADE_AGREEMENTS,
    component: () => import('@/app/modules/InternationalTrade/views/TradeAgreements.vue'),
    beforeEnter: checkMenuGuard,
  },
  {
    path: constants.PATHS.TRADE_ANALITICS_IMPORT_EXPORT,
    component: () => import('@/app/modules/InternationalTrade/views/TradeAnalyticsImportExport.vue'),
    beforeEnter: checkMenuGuard,
  },
  {
    path: constants.PATHS.TRADE_AGREEMENTS_MAP,
    component: () => import('@/app/modules/InternationalTrade/views/TradeInvestmentCommissions.vue'),
    beforeEnter: checkMenuGuard,
  },
  {
    path: constants.PATHS.TRADE_INVESTMENT_AGREEMENTS + constants.PATHS.OPTIONAL_ID_PARAM,
    component: () => import('@/app/modules/InternationalTrade/views/TradeInvestmentAgreements.vue'),
    beforeEnter: checkMenuGuard,
  },
  {
    path: constants.PATHS.ATLAS_COUNTRY + constants.PATHS.OPTIONAL_ID_PARAM,
    name: 'AtlasCountry',
    component: () => import('@/app/modules/InternationalTrade/views/AtlasCountry.vue'),
    beforeEnter: checkMenuGuard,
  },
  {
    path: constants.PATHS.ANALITCS_SERVICES_STRIINDEX,
    component: () => import('@/app/modules/InternationalTrade/views/AnalyticsServicesStriindex.vue'),
    // beforeEnter: checkMenuGuard,
    // TO DO: строка '/analitcs-services-striindex' не приходит с бэка по эндпоинту /api/menu/menu , поэтому пока закомментировал beforeEnter-проверку.
    // Так как пока она не приходит, страница блочится в любом случае независимо от того, включена она в админке или нет.
  },
];
